<template>
    <el-select
        filterable
        remote
        class="remote-select-wrapper"
        value-key="value"
        :class="{ 'is-error': isError }"
        :value="value"
        :placeholder="props.placeholder"
        :disabled="props.disabled"
        :remote-method="queryLabel"
        :loading="loading"
        :style="props.style"
        :multiple="props.multiple"
        @change="changeHandler"
    >
        <el-option v-for="item in options" :key="item.key || item.value" :label="item.label" :value="item.value" />
    </el-select>
</template>

<script>
export default {
    name: "RemoteSelect",
    props: ["value", "widget", "verifyInfo", "rules", "formvalue"],
    data() {
        return {
            loading: false,
            options: this.widget.props.options || [],
            queryParams: {}
        };
    },
    computed: {
        props() {
            return this.widget.props;
        },
        isError() {
            return this.verifyInfo && this.verifyInfo.isValid === false;
        }
    },
    watch: {
        formvalue() {
            if (!this.widget.props.relates) {
                return;
            }
            let needQuery = false;
            this.widget.props.relates.forEach(relate => {
                if (this.queryParams[relate] !== this.formvalue[relate]) {
                    needQuery = true;
                }
                this.queryParams[relate] = this.formvalue[relate];
            });
            if (needQuery) {
                this.queryMethod({ value: this.value }, this.formvalue);
            }
        }
    },
    created() {
        this.queryMethod({ value: this.value }, this.formvalue);
    },
    methods: {
        changeHandler(newValue) {
            this.$emit("change", newValue);
            this.verifyHandler(newValue);
        },
        queryLabel(label) {
            this.queryMethod({ label }, this.formvalue);
        },
        queryMethod(query, formvalue) {
            this.loading = true;

            const searchMethod = this.props.remoteMethod;
            searchMethod(query, formvalue)
                .then(options => {
                    this.options = options;
                    this.loading = false;
                })
                .catch(() => {
                    this.options = [];
                    this.loading = false;
                });
        },
        verifyHandler(newValue) {
            if (!this.rules.some(rule => rule.required)) {
                return;
            }

            const verifyInfo = newValue != null && newValue != "" ? { isValid: true, message: "" } : { isValid: false, message: "请输入必要内容" };
            this.$emit("verify", verifyInfo);
        }
    }
};
</script>

<style scoped lang="less">
.is-error {
    /deep/ input {
        border: 1px solid #f33535;
    }
}
</style>
